import { CheckoutDiscountProfileAttributes } from './checkout-discount-profile-attributes.interface';

export interface CheckoutDiscountProfileAttributesCC
  extends CheckoutDiscountProfileAttributes {
  ccDiscountCodeApplied: string;
}
